
import React from 'react';
import { Settings } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useIsMobile } from '@/hooks/use-mobile';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "@/components/ui/drawer";
import { ExecutorSettings } from './ExecutorSettings';

interface SettingsDialogProps {
  speed: number;
  setSpeed: (speed: number) => void;
}

export const SettingsDialog: React.FC<SettingsDialogProps> = ({ speed, setSpeed }) => {
  const isMobile = useIsMobile();
  
  const SettingsContainer = isMobile ? Drawer : Dialog;
  const SettingsTrigger = isMobile ? DrawerTrigger : DialogTrigger;
  const SettingsContent = isMobile ? DrawerContent : DialogContent;
  const SettingsHeader = isMobile ? DrawerHeader : DialogHeader;
  const SettingsTitle = isMobile ? DrawerTitle : DialogTitle;
  const SettingsDescription = isMobile ? DrawerDescription : DialogDescription;
  const SettingsFooter = isMobile ? DrawerFooter : null;
  const SettingsClose = isMobile ? DrawerClose : null;
  
  return (
    <SettingsContainer>
      <SettingsTrigger asChild>
        <Button variant="outline" size="sm" className="gap-1">
          <Settings className="h-4 w-4" />
          <span className={isMobile ? 'sr-only' : ''}>Settings</span>
        </Button>
      </SettingsTrigger>
      <SettingsContent>
        <SettingsHeader>
          <SettingsTitle>Executor Settings</SettingsTitle>
          <SettingsDescription>
            Configure how the policy executor will run
          </SettingsDescription>
        </SettingsHeader>
        
        <ExecutorSettings 
          speed={speed}
          setSpeed={setSpeed}
        />
        
        {SettingsFooter && (
          <SettingsFooter>
            <SettingsClose asChild>
              <Button>Close</Button>
            </SettingsClose>
          </SettingsFooter>
        )}
      </SettingsContent>
    </SettingsContainer>
  );
};
